<template>

    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner :admin="false" />
    </b-container>

    <b-container v-else class="content-new-audit">
        <h2 class="new-audit-header">Создание аудита</h2>
        <hr class="my-4"/> 

        <filter-by-tags v-model="selectedTag"
                        :options="parentTags" />

        <hr class="my-4"/> 

        <b-row v-if="!activities || !activities.length" 
               class="m-0 center filter-by-tags-stub-label">
            Сначала Вы должны выбрать группу тегов и тег
        </b-row>

        <div v-else class="content-activities">

            <b-radio v-for="(item, index) in activities"
                     v-model="activityId"                         
                     :key="index"
                     :value="item.Id"
                     class="audit-add-radio"
                     @change="createAudit">
                    
                <span class="pointer"> {{item.Name}} </span>
            </b-radio>

        </div>

    </b-container>
</template>

<script>
import '@/assets/styles/client/audit/auditAdd.css'

import AllRoutes from '@/routes/all.routes'

import apiService from '@/services/api.service'

import Spinner from '@/components/shared/Spinner'
import Loading from '@/store/models/Loading'

import FilterByTags from '@/components/client/tags/FilterByTags'

export default {
    
    data: function(){
        var load = new Loading();
        this.getDependency(load);

        return{
            load: load,
            activityId: 0,
            parentTags: [],

            selectedTag: null
        };
    },
    computed: {
        activities: function() {
            return this.selectedTag ? this.selectedTag.Activities : [];
        }
    },
    methods: {
        getDependency: function(load){
            load.Calculate(true);

            apiService.Client.Activities.GetTags()
                .then(response => {        
                    this.parentTags = response.data;
                    load.Calculate(false);
                })
                .catch(error => load.Calculate(false));
        },
        createAudit: function(value) {     
          const auditlocalTimeZone = `${((Math.abs(new Date().getTimezoneOffset()) / 60) > 9)
            ? Math.abs(new Date().getTimezoneOffset()) / 60
            : "0" + Math.abs(new Date().getTimezoneOffset()) / 60}:00:00`


            this.load.Calculate(true);

            this.activityId = value;

            apiService.Client.Audit.PostCreate(this.activityId, auditlocalTimeZone)
                .then(response => {
                    this.$router.push(AllRoutes.Client.Audit.Index + `?id=${response.data}`);
                })
                .catch(error => this.load.Calculate(false));
        }
    },
    components: {
        Spinner,
        FilterByTags
    }
};
</script>